import { useState } from 'react'

import { Space } from 'app/common/templates-next/report-template'

import { Filters } from './filters'
import { Result } from './result/Result'

type Props = {
  profileLink: string
}

export const FinancesSummaryWriteOff = ({ profileLink }: Props) => {
  const [reportId, setReportId] = useState<null | string>(null)

  return (
    <>
      <Filters onReportId={setReportId} profileLink={profileLink} />
      <Space />
      <Result reportId={reportId} onReportId={setReportId} />
    </>
  )
}
